import { pageBannerTop, menuLang } from '../layout';
import Modal from 'bootstrap/js/dist/modal';
document.addEventListener("DOMContentLoaded", function(){
	pageBannerTop();
	menuLang();
});

document.addEventListener('wpcf7mailsent', function(event) {
    var modalContact = document.getElementById('modalContact');
    var modal = new Modal(modalContact);
    modal.show();
  }, false);